// Hook to return a slugified value
import * as React from 'react';

import { slugify } from '../utils';

export function useSlug(...args: string[]): string[] {
  return React.useMemo(() => {
    return args.map((i) => slugify(i));
  }, [args]);
}
